const DEFAULT_LANGUAGE = 'DE'

const LOCALISED_ENHANCED_TEXT_MAP = {
    DE: {
        m: 'Herr',
        f: 'Frau',
    },
    AT: {
        m: 'Herr',
        f: 'Frau',
    },
    CH: {
        m: 'Herr',
        f: 'Frau',
    },
    GB: {
        m: 'Mr.',
        f: 'Mrs.',
    },

}
const getLocalisedEnhancedText = (language, text) => {
    return LOCALISED_ENHANCED_TEXT_MAP[language]
        ? LOCALISED_ENHANCED_TEXT_MAP[language][text]
        : LOCALISED_ENHANCED_TEXT_MAP[DEFAULT_LANGUAGE][text]
}
export default (texts = {}) => {
    const textsWithUppercasedKeys = Object.keys(texts).reduce((obj, nextKey) => {
        obj[nextKey.toUpperCase()] = texts[nextKey]
        return obj
    }, {})

    return (language = DEFAULT_LANGUAGE, replacements = {}) => {
        const languageUpperCase = (language || DEFAULT_LANGUAGE).toUpperCase()
        const baseText = textsWithUppercasedKeys[languageUpperCase] || textsWithUppercasedKeys[DEFAULT_LANGUAGE]
        return injectValues(baseText, replacements, language).trim()
    }
}

const injectValues = (text, replacements = {}, language) => {
    let output = text
    for (const key in replacements) {
        const replacedText = getLocalisedEnhancedText(language, replacements[key]) || replacements[key]
        output = output.replace(new RegExp('\\$' + key, 'g'), replacedText)
    }
    return output
}



// WEBPACK FOOTER //
// ./src/util/localized-text-with-replacements.js